// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__main___vG1bQ {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 260px;
    padding-bottom: 8vh;
    min-height: 90vh;
    padding-top: var(--navbar-height);
}

.style__screenContainer___q1Bqu {
    display: flex;
    /*padding: 3vw;*/
    flex-direction: column;
    overflow-x: hidden;
    padding-left: 52px;
    padding-top: 20px;

    /*min-height: 100vh;*/
    width: 100%;
}

.style__sectionTitleContainer___QQPh8 {
    border-bottom: 1px solid lightgrey;
    padding-bottom: 1vh;
}

.style__sectionTitle___BGksn {
    font-weight: bold;
    font-size: 15px;
}

.style__sectionCount___q0hLa {
    font-size: 15px;
    color: grey;
}

.style__stackContainer___q7opr {
    display: flex;
    flex-direction: row;
    margin-bottom: 2vh;
}

.style__stackItem___vEgVH {
    display: flex;
    justify-content: center;
    align-items: center;
}

.style__stackItemTitle___gFV5z {
    font-size: 20px;
    transition: background-color 0.3s ease;
    padding: 8px;
    border-radius: 10px;
}

.style__stackItemTitle___gFV5z:hover {
    background-color: var(--hover-color);
}
`, "",{"version":3,"sources":["webpack://./src/client/PhotosScreen/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;;IAEjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-left: 260px;\n    padding-bottom: 8vh;\n    min-height: 90vh;\n    padding-top: var(--navbar-height);\n}\n\n.screenContainer {\n    display: flex;\n    /*padding: 3vw;*/\n    flex-direction: column;\n    overflow-x: hidden;\n    padding-left: 52px;\n    padding-top: 20px;\n\n    /*min-height: 100vh;*/\n    width: 100%;\n}\n\n.sectionTitleContainer {\n    border-bottom: 1px solid lightgrey;\n    padding-bottom: 1vh;\n}\n\n.sectionTitle {\n    font-weight: bold;\n    font-size: 15px;\n}\n\n.sectionCount {\n    font-size: 15px;\n    color: grey;\n}\n\n.stackContainer {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 2vh;\n}\n\n.stackItem {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.stackItemTitle {\n    font-size: 20px;\n    transition: background-color 0.3s ease;\n    padding: 8px;\n    border-radius: 10px;\n}\n\n.stackItemTitle:hover {\n    background-color: var(--hover-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `style__main___vG1bQ`,
	"screenContainer": `style__screenContainer___q1Bqu`,
	"sectionTitleContainer": `style__sectionTitleContainer___QQPh8`,
	"sectionTitle": `style__sectionTitle___BGksn`,
	"sectionCount": `style__sectionCount___q0hLa`,
	"stackContainer": `style__stackContainer___q7opr`,
	"stackItem": `style__stackItem___vEgVH`,
	"stackItemTitle": `style__stackItemTitle___gFV5z`
};
export default ___CSS_LOADER_EXPORT___;
